var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.495 4c-4.332-.006-7.946 3.176-8.315 7.32-.368 4.143 2.632 7.867 6.902 8.566 4.27.7 8.387-1.86 9.47-5.886h-2.168c-1.06 2.877-4.2 4.532-7.297 3.846-3.098-.686-5.165-3.494-4.805-6.526.36-3.032 3.034-5.321 6.213-5.32a6.296 6.296 0 0 1 4.399 1.78L13.542 11h7.291V4l-2.449 2.35c-1.558-1.505-3.678-2.351-5.89-2.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.8e63818c9e13c8b399eb801fad05feaa.svg";
export { ForwardRef as ReactComponent };